module.exports = __webpack_public_path__ + "img/ferpe.a19ae7a9.jpeg";